import React from "react";
import AppBar from "./AppBar";
import { Layout } from "react-admin";

export const Empty = () => <></>;


export default (props: any) => <Layout {...props} appBar={AppBar} />;